import { render, staticRenderFns } from "./storeFreight.vue?vue&type=template&id=b44fe084&scoped=true"
import script from "./storeFreight.vue?vue&type=script&lang=js"
export * from "./storeFreight.vue?vue&type=script&lang=js"
import style0 from "./storeFreight.vue?vue&type=style&index=0&id=b44fe084&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44fe084",
  null
  
)

export default component.exports